import { render, staticRenderFns } from "./SchematicPreview.vue?vue&type=template&id=2d55fa23&scoped=true"
import script from "./SchematicPreview.vue?vue&type=script&lang=js"
export * from "./SchematicPreview.vue?vue&type=script&lang=js"
import style0 from "./SchematicPreview.vue?vue&type=style&index=0&id=2d55fa23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d55fa23",
  null
  
)

export default component.exports